import { useCallback } from 'react';
import uuid from 'react-uuid';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface GlCodeResponse {
  id: number;
  code: string;
  description: string;
  isDeleted: boolean;
  name: string;
  selected: boolean;
  isDirty: boolean;
  rowId: string;
}

const useGetAllGlCodeApi = (companyId: string) => {
  const call = useCallback(async () => {
    try {
      if (!companyId) {
        return [] as GlCodeResponse[];
      }
      const res = await axiosInstance.get<GlCodeResponse[]>(api.getAllGlCode(companyId));
      const data = res.data.map((glCode) => ({
        ...glCode,
        selected: false,
        isDirty: false,
        name: `${glCode.code} ${glCode.description}`,
        rowId: uuid(),
      }));
      return data;
    } catch (error) {
      throw new Error(error);
    }
  }, [companyId]);

  const { value } = useAsync(call, true);

  return {
    glCodes: value || [],
  };
};

export default useGetAllGlCodeApi;
